import { exceedsCashLimit, formatDate, formatMoney, formatNumber, UMA_CASH_LIMIT, withVat } from "@pcj/shared";
import { Coins, TriangleAlert } from "lucide-react";
import { Banner, EmptyState, Pill, SectionTitle, Table, td, th } from "../../components/ui";
import { useCompany } from "./CompanyLayout";

/** Cash and precious-metal payments against the art. 32 limit (compared WITH VAT). */
export function CashTab() {
  const { operations, clientById, thresholds } = useCompany();
  const cash = operations.filter((op) => op.paymentMethod === "cash");

  return (
    <div className="space-y-4">
      <SectionTitle
        title="Monitoreo de efectivo y metales preciosos"
        subtitle="Restricción del art. 32 LFPIORPI · función 6 del art. 41 RCG"
      />
      <Banner tone="warning">
        El tope de {formatNumber(UMA_CASH_LIMIT)} UMA (≈ {formatMoney(thresholds.cashLimit)}) se calcula{" "}
        <strong>con IVA incluido</strong>, a diferencia de los umbrales de identificación y de Aviso.
      </Banner>
      {cash.length === 0 ? (
        <EmptyState icon={Coins} title="No se han registrado pagos en efectivo" />
      ) : (
        <Table>
          <thead className="bg-gray-50">
            <tr>
              <th className={th}>Fecha</th>
              <th className={th}>Cliente</th>
              <th className={th}>Sin IVA</th>
              <th className={th}>Con IVA</th>
              <th className={th}>Estatus</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {cash.map((op) => (
              <tr key={op.id}>
                <td className={`${td} text-gray-600`}>{formatDate(op.date)}</td>
                <td className={`${td} font-medium text-gray-900`}>{clientById.get(op.clientId)?.name ?? "—"}</td>
                <td className={`${td} text-gray-700`}>{formatMoney(op.amount)}</td>
                <td className={`${td} text-gray-700`}>{formatMoney(withVat(op.amount))}</td>
                <td className={td}>
                  {exceedsCashLimit(op, thresholds) ? (
                    <Pill tone="red" icon={TriangleAlert}>
                      Excede el tope
                    </Pill>
                  ) : (
                    <Pill tone="green">Dentro del tope</Pill>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}
